import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';
import ReactDOM from 'react-dom';

import {UserInfoState} from 'onboarding/new-user-flow/RoleInfoScreen';

interface Props {
  isLoading: boolean;
  handleClickNextScreen: (e: React.FormEvent<HTMLFormElement>, state: UserInfoState) => void;
}

class ProclaimedCommercialRoleInfoScreen extends React.Component<Props, UserInfoState> {
  override state: UserInfoState = {
    title: '',
    teamName: '',
    phoneNumber: '',
    company: '',
  };

  companyInputRef = React.createRef<HTMLInputElement>();

  override componentDidMount(): void {
    (ReactDOM.findDOMNode(this.companyInputRef.current) as HTMLInputElement).focus();
  }

  fieldsValid = (): boolean =>
    this.state.company !== undefined &&
    this.state.company !== '' &&
    this.state.phoneNumber !== undefined &&
    this.state.phoneNumber !== '';

  override render(): JSX.Element {
    const disableClickToNextScreen = !this.fieldsValid() || this.props.isLoading;

    return (
      <form
        {...getTestProps({component: 'ProclaimedCommercialRoleInfoScreen', element: 'root'})}
        onSubmit={(e): void => {
          this.props.handleClickNextScreen(e, this.state);
        }}
      >
        <label>Company name</label>
        <input
          placeholder="e.g. Benchling"
          ref={this.companyInputRef}
          onChange={(e) => {
            this.setState({company: e.target.value});
          }}
          value={this.state.company ?? undefined}
          className="input-lg form-control u-spacing-bottom"
          name="company"
        />
        <label>Phone number</label>
        <input
          placeholder="e.g. 415-555-5555"
          onChange={(e) => {
            this.setState({phoneNumber: e.target.value});
          }}
          value={this.state.phoneNumber ?? undefined}
          className="input-lg form-control u-spacing-bottom"
          name="phoneNumber"
        />
        <label>Team</label>
        <input
          placeholder="e.g. Protein Engineering (optional)"
          onChange={(e) => {
            this.setState({teamName: e.target.value});
          }}
          value={this.state.teamName ?? undefined}
          className="input-lg form-control u-spacing-bottom"
          name="teamName"
        />
        <label>Role</label>
        <input
          placeholder="e.g. Senior Scientist (optional)"
          onChange={(e) => {
            this.setState({title: e.target.value});
          }}
          value={this.state.title ?? undefined}
          className="input-lg form-control u-spacing-bottom"
          name="title"
        />
        <div className="roleInfoScreen-nextScreenButtonContainer">
          <button
            className="button button--large button--primary u-spacing-top pull-right"
            disabled={disableClickToNextScreen}
            type="submit"
          >
            {this.props.isLoading ? 'Submitting details...' : 'Next'}
          </button>
        </div>
      </form>
    );
  }
}

export default ProclaimedCommercialRoleInfoScreen;
